/// <amd-module name="Feed/Legacy/Components/PackageMessagePanel" />
import * as React from "react";

import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { TooltipHost, TooltipOverflowMode } from "VSSUI/Tooltip";

import * as PackageResources from "Feed/Common/Resources";

export interface IPackageMessagePanelProps {
    message: string;
}

export class PackageMessagePanel extends React.PureComponent<IPackageMessagePanelProps> {
    public render(): JSX.Element {
        const messageBarText = this.props.message;

        if (messageBarText && messageBarText.length > 0) {
            return (
                <div className="package-message-panel" aria-label={PackageResources.AriaLabel_MessageBar}>
                    <TooltipHost content={messageBarText} overflowMode={TooltipOverflowMode.Parent}>
                        <MessageBar className="package-message-bar" severity={MessageBarSeverity.Warning}>
                            {messageBarText}
                        </MessageBar>
                    </TooltipHost>
                </div>
            );
        }

        return null;
    }
}
